export const rexIntegrationKeys = {
  rex: (accountId: string) => [accountId, 'integrations', 'rex'] as const,
  accounts: (accountId: string) =>
    [...rexIntegrationKeys.rex(accountId), 'accounts'] as const,
  locations: (accountId: string) =>
    [...rexIntegrationKeys.rex(accountId), 'locations'] as const
} as const;
